module.exports = __webpack_public_path__ + "static/media/eric_lu.8a13131d.png";